import { Card, CardContent } from "@/components/ui/card"

export default function BartenderResponse({ response, className = "" }) {
  // Format the response text with line breaks
  const formattedText = response?.text || "Here's what I recommend based on your preferences..."

  return (
    <Card className={`mt-8 ${className}`}>
      <CardContent className="p-6 space-y-4">
        <h3 className="text-xl font-semibold">Bartender's Recommendation</h3>

        <div className="prose dark:prose-invert max-w-none">
          {formattedText.split("\n").map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
